import React from 'react';
import { ProviderProps } from '@app/shell/types';
import useSift from '../hooks/useSift';
import useForter from '../hooks/useForter';
import useRiskified from '../hooks/useRiskified';

/**
 * We use memo here to ensure it runs on the server and client.
 *
 * @param children
 * @constructor
 */
const FraudProvider = ({ children }: Pick<ProviderProps, 'children'>) => {
  useSift();
  useForter();
  useRiskified();

  return <>{children}</>;
};

export default FraudProvider;
